export function isType(type: object, value: any): boolean {
	return Object.values(type).indexOf(value) > -1;
}
